import { render } from "./MonetaryChart.vue?vue&type=template&id=9b8858ee&scoped=true&ts=true"
import script from "./MonetaryChart.vue?vue&type=script&lang=ts"
export * from "./MonetaryChart.vue?vue&type=script&lang=ts"

import "./MonetaryChart.vue?vue&type=style&index=0&id=9b8858ee&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b8858ee"]])

export default __exports__